import { Route, Routes } from 'react-router-dom';
import NotFound404 from '../../shared/Errors/NotFound404';
import SellerDashboard from '../Pages/SellerDashboard';

const SellerDashboardRouter = () => (
  <Routes>
    <Route path="/" element={<SellerDashboard title="Dasboard Vendedores" />} />
    <Route
      path="*"
      element={(
        <NotFound404 /> )}
    />
  </Routes>
);

export default SellerDashboardRouter;
